var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThunderstorm = function SvgThunderstorm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.229 6.118a6.966 6.966 0 0 1 13.434 0 5.474 5.474 0 0 1 .58 10.491.995.995 0 0 1-.663-1.875 3.484 3.484 0 0 0-.835-6.754.995.995 0 0 1-.89-.83 4.976 4.976 0 0 0-9.818 0 .995.995 0 0 1-.89.83 3.485 3.485 0 0 0-.835 6.754.995.995 0 1 1-.664 1.875 5.476 5.476 0 0 1 .581-10.492m8.264 3.01c.457.306.58.923.276 1.38l-2.95 4.424h4.112a.994.994 0 0 1 .828 1.546l-3.981 5.97a.995.995 0 1 1-1.655-1.103l2.95-4.424H8.96a.995.995 0 0 1-.828-1.546l3.98-5.97a.995.995 0 0 1 1.38-.276",
    clipRule: "evenodd"
  })));
};
export default SvgThunderstorm;